module.exports = __webpack_public_path__ + "img/owl-blue-back.2f02b2eb.png";